export const AtlassianDocumentationMarkBrand = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.2888 19.925C16.7888 19.325 15.9888 19.425 15.5888 20.125L7.08882 37.125C6.78882 37.825 7.28882 38.625 7.98882 38.625H19.7888C20.1888 38.625 20.4888 38.425 20.6888 38.025C23.2888 32.725 21.6888 24.725 17.2888 19.925Z"
      fill="url(#paint0_linear_994_2105)"
    />
    <path
      d="M23.4888 4.525C18.7888 12.025 19.0888 20.325 22.1888 26.625C25.2888 32.925 27.6888 37.625 27.8888 38.025C28.0888 38.425 28.3888 38.625 28.7888 38.625H40.5888C41.3888 38.625 41.7888 37.825 41.4888 37.125C41.4888 37.125 25.5888 5.325 25.1888 4.525C24.8888 3.825 23.8888 3.825 23.4888 4.525Z"
      fill="#0082FF"
    />
    <defs>
      <linearGradient
        id="paint0_linear_994_2105"
        x1="21.9049"
        y1="22.5804"
        x2="12.9499"
        y2="38.0904"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0050D3" />
        <stop offset="0.923" stopColor="#0082FF" />
      </linearGradient>
    </defs>
  </svg>
);
